import colors from 'theme/_colors.scss';

export const CHART_COMMON_SPACING = {
    spacingTop: 20,
    spacingRight: 24,
    marginLeft: 82,
};
export const monthValue = Date.UTC(2009, 0, 6) - Date.UTC(2009, 0, 1);
export const currentDateEpoch = Date.now();
export const dateFormat = 'DD/MM/YYYY';
export const payloadDateFormat = 'YYYY-MM-DDTHH:mm:ss';
export const REGEX_FOR_REFERENCE_TEMPERATURE = /^$|^(\d{1,3}|\d{0,2})$/; // allow empty or up to 2 digits
export const REGEX_FOR_LUBRICATION_INTERVAL = /^$|^\d{0,5}$/; /* allow empty or up to 5 digits */
export const SPECIAL_CHARS = ['-', '*', '+', '/', '--'];
export const REFERENCE_TEMPERATURE_DEFAULTS = { /* 1: Celsius, 2: Fahrenheit | based on symbol ID in units */
    min: {
        1: 0,
        2: 32
    },
    max: {
        1: 75,
        2: 167
    }
};
export const LUBRICATION_INTERVAL_DEFAULTS = {
    min: 700,
    max: 16800,
    unit: 'h'
};
export const MEASUREMENT_UNIT_GROUP = 4;

export const regreasingNotificationTypes = {
    info: 'info',
    warning: 'warning',
    error: 'error'
};

export const rowIds = {
    maintenanceStatus: 'maintenance-status',
    nextStdLubricationDate: 'next-std-lubrication-date',
    nextCBMLubricationDate: 'next-cbm-lubrication-date',
    lastExecutedLubricationDate: 'last-executed-lubrication'
};

export const lubricationRecommendation = {
    OverDue: {
        maintenanceID: 4,
        iconID: 3,
    },
    Due: {
        maintenanceID: 3,
        iconID: 2,
    },
    Good: {
        maintenanceID: 1,
        iconID: 1,
    },
    Unknown: {
        maintenanceID: 2,
        iconID: 0,
    },
    Unsupported: {
        maintenanceID: 0,
        iconID: -1,
    }
};

export const lubricationActivityTrendTypes = {
    Lubrication: {
        name: 'Lubrication',
        iconID: -1,
        color: colors.jungleGreen
    },
    NewCycle: {
        name: 'NewCycle',
        iconID: -1,
        color: colors.jungleGreen
    },
    Warning: {
        name: 'Warning',
        iconID: 2,
        color: colors.orangePeel
    },
    Alarm: {
        name: 'Alarm',
        iconID: 3,
        color: colors.pomegranate
    },
};
